import React, { useState } from "react";
import axios from "axios";

const ExcelManager = () => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setStatus("📂 Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setStatus("⏳ Uploading...");
      const res = await axios.post(
        "http://localhost:5000/api/upload-excel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setStatus("✅ " + res.data.message);
    } catch (err) {
      setStatus("❌ Upload failed.");
      console.error(err);
    }
  };

  const handleDownload = async () => {
    try {
      setStatus("⏳ Downloading...");
      const res = await axios.get("http://localhost:5000/api/download-excel", {
        responseType: "blob", // important for downloading files
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "items_export.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      setStatus("✅ Download complete.");
    } catch (err) {
      setStatus("❌ Download failed.");
      console.error(err);
    }
  };

  return (
    <div style={styles.container}>
      <h2>📦 Excel Import/Export</h2>
      <div style={styles.section}>
        <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
        <button onClick={handleUpload}>📤 Upload Excel</button>
      </div>
      <div style={styles.section}>
        <button onClick={handleDownload}>📥 Download Excel</button>
      </div>
      {status && <p>{status}</p>}
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial",
    maxWidth: "400px",
    margin: "auto",
    border: "1px solid #ccc",
    borderRadius: "10px",
    marginTop: "50px",
    textAlign: "center",
  },
  section: {
    margin: "20px 0",
  },
};

export default ExcelManager;
